import { gql } from '@apollo/client';

export const getAdhesionComerciosDni = gql`
query AdhesionComerciosDniApi{
    adhesionComerciosDniVuelta (dni:$dni, sexo:$sexo, tramite:$tramite)  
    @rest(type: "AdhesionComerciosDniVuelta", path: "/api/gateway/formulariosComercios/presolicitud/{args.dni}/{args.sexo}/{args.tramite}"){
       nif
       idTramitePrincipal
       apellido
       nombres
       fechaNacimiento
       calle
       altura
       codigoPostal
       ciudad
       municipio
       provincia
       pais
       error
    }
}
`   